// extracted by mini-css-extract-plugin
var _1 = "279px";
var _2 = "ContentMapColumn-module__container--PSJ6f";
var _3 = "ContentMapColumn-module__draggable--wFBe8";
var _4 = "ContentMapColumn-module__drop--vu_2r";
var _5 = "ContentMapColumn-module__header--Ptbd6";
var _6 = "ContentMapColumn-module__headerContent--J3By_";
var _7 = "ContentMapColumn-module__isDragOver--Vd7YR";
var _8 = "ContentMapColumn-module__itemContainer--pjSYt";
var _9 = "ContentMapColumn-module__posts--RyE_m";
var _a = "16px";
var _b = "ContentMapColumn-module__stuck--z_JME";
var _c = "ContentMapColumn-module__unorganized--gysdE";
export { _1 as "columnWidth", _2 as "container", _3 as "draggable", _4 as "drop", _5 as "header", _6 as "headerContent", _7 as "isDragOver", _8 as "itemContainer", _9 as "posts", _a as "specialColumnPadding", _b as "stuck", _c as "unorganized" }
